export const Logo = () => {
  return <img className="logo" src={'/logo192.png'} alt="Logo" />;
};
